import { render, staticRenderFns } from "./bdpay.vue?vue&type=template&id=7dab4ad0&scoped=true&"
import script from "./bdpay.vue?vue&type=script&lang=js&"
export * from "./bdpay.vue?vue&type=script&lang=js&"
import style0 from "./bdpay.vue?vue&type=style&index=0&id=7dab4ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dab4ad0",
  null
  
)

export default component.exports